import React from 'react';

import { useAllJobProspectsState, useAllJobProspectsActions } from './AllJobProspectsContext';

import AllJobProspectsLoader from './AllJobProspectsLoader';
import Stack from '../../Shared/UI/Stack/components/Stack';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import AllJobProspectsTable from './AllJobProspectsTable';
import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import DeleteJobProspectForm from './DeleteJobProspectForm';
import ClosedJobModal from './ClosedJobModal';
import styles from './AllJobProspects.module.scss';

const AllJobProspectsContent = () => {
  const state = useAllJobProspectsState();
  const { closeDeleteJobProspectModal } = useAllJobProspectsActions();

  if (state?.loading) {
    return (
      <div className={styles.pageLayout}>
        <p style={{ textAlign: 'center', fontWeight: 'bold' }}>Loading</p>
      </div>
    );
  }

  return (
    <div className={styles.pageLayout}>
      <Stack gap="lg">
        <PageTitle text={'All Job Prospects'} />
        <AllJobProspectsTable />
      </Stack>
      <StandardModal
        isOpen={state?.deleteJobProspectModalIsOpen}
        contentLabel={'Delete This Job Prospect'}
        onRequestClose={() => {
          closeDeleteJobProspectModal();
        }}
      >
        <DeleteJobProspectForm />
      </StandardModal>
      <ClosedJobModal />
    </div>
  );
};

const AllJobProspects = () => {
  return (
    <>
      <AllJobProspectsLoader />
      <AllJobProspectsContent />
    </>
  );
};

export default AllJobProspects;
